import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, fromEvent, merge, of, Subject, BehaviorSubject } from 'rxjs';
import { catchError, mapTo } from 'rxjs/operators';
import { AngularFireStorage, AngularFireStorageReference, AngularFireUploadTask } from 'angularfire2/storage';
import { map } from 'rxjs/operators';

import { MAX_SIZE_LOGO_LENGTH } from '@utils';
import { environment } from '@environments/environment';

const BUCKETS = environment.buckets;

@Injectable()
export class FirebaseImagesService {
  private _selectedFile: File;
  storageReference: AngularFireStorageReference;
  task: AngularFireUploadTask;
  uploadProgress: Observable<number>;
  downloadURL: Observable<string>;

  constructor(
    private afStorage: AngularFireStorage,
  ) {
    this._selectedFile = null;
    this.uploadProgress = null;
  }

  validFile(file: File, maxSize: number = MAX_SIZE_LOGO_LENGTH): object {
    let response = {strMessage: '', error: false};
    if (file === null || typeof file === 'undefined') {
      response = {
        strMessage: 'Debe seleccionar una imagen',
        error: true,
      };
    } else {
      const imageSize = file.size / 1000;
      if (imageSize > maxSize) {
        response = {
          strMessage: 'Tamaño imagen excede el límite permitido',
          error: true,
        };
      }
    }
    return response;
  }

  uploadImage(file: File) {
    this._selectedFile = file;
    if (this._selectedFile !== null) {
      const images_dir = BUCKETS.companyImages;
      const id = Math.random().toString(36).substring(2);
      this.storageReference = this.afStorage.ref(`${images_dir}/${this._selectedFile.name}`);
      this.task = this.storageReference.put(this._selectedFile);
      this.uploadProgress = this.task.percentageChanges().pipe(
        map((progress: number) => {
          return progress;
        })
      );
      this.downloadURL = this.storageReference.getDownloadURL();
    }
  }
}
